const module = {
  config: {
    name: 'dashboard-PMIS',
    desc: 'Laporan Manajemen Proyek Departemen Infrastruktur II',
    icon: 'ri-dashboard-line',
    layout: false
  },
  routes: [
    { name: 'summary-dashboard', icon: 'ri-database-2-fill', path: '/dashboard', attr: { hideNav: true }, component: () => import('./main-dashboard.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/dashboard/_index.js